var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"previewClipartsComponent"},_vm._l((_vm.label.cliparts_blocks),function(clipart){return _c('app-previewclipart',{attrs:{"clipart":clipart,"label":_vm.label}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d19875ba","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Preview/PreviewCliparts.vue
// module id = 81
// module chunks = 0